import { RootState, Modal } from "../../../../models";

export type State = Pick<RootState, "modals">;
export const getModals = (state: State): Modal[] => state.modals || [];

export const isSecretNumberModal = (modal: Modal): boolean => modal.forEntryId === "SECRET_NUMBER_MODAL";
export const isFamilyDiscountModal = (modal: Modal): boolean => modal.forEntryId === "FAMILY_DISCOUNT_MODAL";
